import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Session Expired Modal
 * Displays when refresh token fails and user needs to re-authenticate
 */
const SessionExpiredModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleSessionExpired = (): void => {
      setIsOpen(true);
    };

    window.addEventListener('auth:show-session-expired-modal', handleSessionExpired);
    return () => {
      window.removeEventListener('auth:show-session-expired-modal', handleSessionExpired);
    };
  }, []);

  const handleClose = (): void => {
    setIsOpen(false);
    navigate('/', { replace: true });
  };

  if (!isOpen) {return null;}

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleClose}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0 w-12 h-12 rounded-full bg-yellow-100 dark:bg-yellow-900 flex items-center justify-center">
            <svg
              className="w-6 h-6 text-yellow-600 dark:text-yellow-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h3 className="ml-4 text-lg font-semibold text-gray-900 dark:text-white">
            Session Expired
          </h3>
        </div>

        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Your session has ended for security reasons. Please sign in again to continue using
          Vaera.
        </p>

        <div className="flex justify-end">
          <button
            onClick={handleClose}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            Sign In Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
